import AuthService from '../../utilities/services/auth.service'
import { BuyerTypesReportWrapper } from '../../components'

export default function BuyerTypesReportPage() {
  const organization = AuthService.getOrg()?.[0]

  return <BuyerTypesReportWrapper organization={organization} />
}
